import React, { useState } from "react";
import { Box, Tabs, Tab, Paper, Typography } from "@mui/material";
import LeibnizScreen from "./LeibnizScreen";
import KaTeXScreen from "./KaTeXScreen";
import MathLibScreen from "./MathLibScreen";
import { BookOpen, Activity, Calculator } from "lucide-react";

interface ReferenceToolsProps {
    onSelectMath?: (math: string) => void;
}

const ReferenceTools: React.FC<ReferenceToolsProps> = ({ onSelectMath }) => {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column", bgcolor: "#fff" }}>
            <Paper elevation={0} sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    variant="fullWidth"
                    indicatorColor="primary"
                    textColor="primary"
                    sx={{
                        minHeight: "48px",
                        "& .MuiTab-root": {
                            fontSize: "12px",
                            fontWeight: 600,
                            textTransform: "none",
                            minHeight: "48px",
                            gap: 1
                        }
                    }}
                >
                    <Tab icon={<BookOpen size={16} />} label="Leibniz" />
                    <Tab icon={<Activity size={16} />} label="Live KaTeX" />
                    <Tab icon={<Calculator size={16} />} label="Math Lib" />
                </Tabs>
            </Paper>

            <Box sx={{ flex: 1, overflowY: "auto", p: 0 }}>
                {activeTab === 0 && <LeibnizScreen />}
                {activeTab === 1 && <KaTeXScreen />}
                {activeTab === 2 && <MathLibScreen />}
            </Box>
        </Box>
    );
};

export default ReferenceTools;
